import React from 'react'
import s from './index.module.scss'
import Logo from '../UI/Logo'

const Header = () => {
	return (
		<header className={s.header}>
			<Logo />
		</header>
	)
}

export default Header
